export enum Variants {
  H5 = 'h5',
  Subtitle1 = 'subtitle1',
  Subtitle2 = 'subtitle2',
  Body2 = 'body2',
}
